<template>
	<div>
		<card title="Notificaciones" icon="fas fa-mail-bulk" style="min-height: 800px;">
			<div class="table-responsive">
				<div class="col-12">
					<div class="card">
						<div class="card-body">
							<form @submit.prevent="store()">
								<div class="row">
									<div class="col-md-2">
										<b-form-checkbox @change="changeAllNotification()" class="mt-4" switch  v-model="allNotification">
										Seguimento Total
										</b-form-checkbox>
									</div>
									<div class="col-md-2">
										<b-form-checkbox  @change="changeExternalEmail()" class="mt-4" switch  v-model="isExternalEmail">
										Email Externo
										</b-form-checkbox>
									</div>
									<div class="col-md-3">
										<label for>Etapa:</label>
										<v-select :disabled="allNotification" :options="steps" v-model="step">
											<span slot="no-options">No se encontraron registros</span>
										</v-select>
									</div>
									<div v-if="!isExternalEmail" class="col-md-4">
										<label for>Usuario:</label>
										<v-select :options="users" v-model="user">
											<span slot="no-options">No se encontraron registros</span>
										</v-select>
									</div>
									<div v-if="isExternalEmail" class="col-md-4">
										<label for>Email Externo:</label>
										<input type="email" v-model="externalEmail" class="form-control">
									</div>
									<div class="col-md-1">
										<button class="btn btn-success" type="submit" style="margin-top: 28px;"><i class="fa fa-plus"></i> Agregar</button>
									</div>
								</div>
							</form>
						</div>
					</div>
					<div class="row mt-4">
						<div class="col-4">
							<div class="card">
								<div class="card-header">
									<h4>Seguimento Total</h4>
								</div>
								<div class="card-body">
									<div class="row">
										<table class="table table-stripped table-sm">
											<thead class="thead-dark">
												<tr>
													<th>Email</th>
													<th>Externo</th>
													<th></th>
												</tr>
											</thead>
											<tbody v-if="notifications.allNotificationsEmail && notifications.allNotificationsEmail.length > 0">
												<tr v-for="nAll in notifications.allNotificationsEmail" v-bind:key="nAll.id">
													<td style="width: 80%;">
														<span class="badge badge-success m-text">{{ nAll.email }}</span>
													</td>
													<td>
														<span v-if="nAll.externalEmail" class="badge badge-info"><i class="fa fa-check"></i></span>
													</td>
													<td style="text-align: right;"><button class="btn btn-danger btn-sm" @click="deleteNotification(nAll, true)"><i class="fas fa-trash"></i></button></td>
												</tr>
											</tbody>
										</table>
									</div>
								</div>
							</div>
						</div>
						<div class="col-8">
							<div class="card" style="min-height: 800px;">
								<div class="card-header">
									<h4>Seguimento por Etapa</h4>
								</div>
								<div class="card-body">
									<div class="row">
											<div v-for="item in steps" v-bind:key="item.code" class="col-6">
												<div class="card mb-4">
													<div class="card-header" style="text-align: left !important;">
														<h5>Etapa: {{ item.label }}</h5>
													</div>
													<div class="card-body">
														<div class="row">
															<table class="table table-stripped table-sm">
																<thead class="thead-dark">
																	<tr>
																		<th style="text-align: left;">Email</th>
																		<th style="text-align: left;">Externo</th>
																		<th></th>
																	</tr>
																</thead>
																<tbody v-if="notifications.notifications && notifications.notifications.length > 0">
																	<tr v-for="nStep in notifications.notifications.filter(x => x.state == item.code)"  v-bind:key="nStep.id">
																		<td style="width: 80%; text-align: left;">
																			<span class="badge badge-success m-text">{{ nStep.email }}</span>
																		</td>
																		<td>
																			<span v-if="nStep.externalEmail" class="badge badge-info"><i class="fa fa-check"></i></span>
																		</td>
																		<td style="text-align: right;"><button class="btn btn-danger btn-sm" @click="deleteNotification(nStep, false)"><i class="fas fa-trash"></i></button></td>
																	</tr>
																</tbody>
															</table>
														</div>
													</div>
												</div>
											</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</card>
	</div>
</template>

<script>
import { Get, Delete, Post } from "../../helper/axios.js";
import Card from "../../components/Card.vue";
export default {
	components: {
		Card
	},
	data() {
		return {
			users: [],
			notifications: [],
			Post,
			Delete,
			apiUrl: this.$store.getters.apiUrl,
			modalTitle: '',
			Get,
			user: {},
			step: {},
			allNotification: false,
			isExternalEmail: false,
			externalEmail: '',
			steps: [
				{
					code: 1,
					label: "Enviado",
				},
				{
					code: 2,
					label: "Validación Enología",
				},
				{
					code: 3,
					label: "Validación Componentes",
				},
				{
					code: 4,
					label: "Calidad",
				},
				{
					code: 5,
					label: "Valido para Despacho",
				},
				{
					code: 6,
					label: "Despacho Bodega",
				},
				{
					code: 7,
					label: "Despachado",
				},
				{
					code: 8,
					label: "Confirmado",
				},
				{
					code: 9,
					label: "Arribado Parcialmente",
				},
				{
					code: 10,
					label: "Despachado Parcialmente",
				},
				{
					code: 11,
					label: "Despachado Rechazado",
				},
				{
					code: -1,
					label: "Rechazado por Calidad",
				},
				{
					code: -2,
					label: "Invalidado",
				},
			]
		};
	},
	created() {
		this.index();
	},
	methods: {
		index() {
			this.user = {};
			this.step = {};
			this.externalEmail = '';
			this.allNotification = false;
			this.isExternalEmail = false;
			this.users = [],
			this.notifications = [],
			this.getUsers();
			this.getNotifications();
		},
		getUsers(){
			this.$store.commit('setLoading',true)
			this.Get(this.apiUrl + "v1/users?NotPaginated=true", (res) => {
				res.data.data.forEach((item) => {
					this.users.push({
						code: item.id,
						label: item.email + ' - ' + item.fullName
					})
				});
				this.$store.commit('setLoading',false)
			});
		},
		getNotifications(){
			this.$store.commit('setLoading',true)
			this.Get(this.apiUrl + "v1/notifications", (res) => {
				this.notifications = res.data.data;
				this.$store.commit('setLoading',false)
			});
		},
		changeExternalEmail(){
			if (!this.isExternalEmail)
				this.user = {}
		},
		changeAllNotification(){
			if (!this.allNotification)
				this.step = {}
		},
		store() {
			let data = {
				state: !this.allNotification ? this.step.code : null,
				email: this.isExternalEmail ? this.externalEmail : '',
				userId: !this.isExternalEmail && this.user ? this.user.code : null,
				externalEmail: this.isExternalEmail,
				allNotification: this.allNotification
			}

			this.$store.commit("setLoading", true);
			this.Post(`${this.apiUrl}v1/notifications/`, data, () => {
				this.$store.commit("setLoading", false);
				window.toastr.success('Email asignado correctamente.');
				this.index();
			});
		},
		deleteNotification(notification, isTotal = false){
			let email =  notification.email
			let stateSelect = this.steps.filter(x => x.code == notification.state)[0]
			let text = "";
			if (isTotal)
				text = "Seguimiento Total";
			else
				text = "Etapa: " + stateSelect.label;
			this.$swal({
                title: "¿Desea eliminar el Email: " + notification.email + "?",
                text: text,
                icon: "warning",
                showCancelButton: true,
                confirmButtonColor: "#3085d6",
                cancelButtonColor: "#d33",
            }).then((result) => {
                if (result.value) {
                    this.Delete(this.apiUrl + "v1/notifications/" + notification.id, () => {
                        window.toastr.success(
                            "El Email " + email + " ha sido eliminada correctamente."
                        );
                        this.index();
                    });
                }
            });
		}
	},
	computed: {
		urlQuery() {
			return this.getUrlQuery()
		}
	}

}

</script>